module.exports = __webpack_public_path__ + "static/media/workingmemory-words-12.c887456c.mp3";